module.exports = "/img/_/_/_/assets/images//input.png?64ab7d7781e82c3d4a25f40ab0c131b3";